import React, { useState, useEffect, forwardRef, useImperativeHandle, } from "react";
import { getPassCode, checkApiError } from "../../utils";
import { Dropdown, Modal, Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ContactInfo = forwardRef(({ showLoading, eventId }, ref) => {
  const navigate = useNavigate();
  const [encoraUsers, setEncoraUsers] = useState([]);
  const [coordinators, setCoordinators] = useState([]);
  const [committeEmail, setcommitteEmail] = useState("");
  const [isEventCoordinatorSelected, setIsEventCoordinatorSelected] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  let testSelectedCoordinator = [];

  const applyContactToCoordinator = (_coordinatorList) => {
    const updateContantNumber = _coordinatorList.map((coordinator) => {
      coordinator['contactNumber'] = coordinator.coordinatorContactNumber;
      delete coordinator.coordinatorContactNumber;
      return coordinator;
    });
    
    setCoordinators(updateContantNumber);
    testSelectedCoordinator = updateContantNumber;
  }

  const getCoordinatorsByEventId = async (eventId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/EventCoordinator/getCoordinatorByEventId?EventId=${eventId}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getPassCode()}`,
          },
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        if(data.statusCode === 200){
          applyContactToCoordinator(data.eventCoordinatorDetails);
          getEncoraUsers();
        }else{
          setCoordinators([]);
        }
      } else {
      }
    } catch (error) {
      console.log(error);
    }finally{
      showLoading(false);
    }
  }
    
  const getEncoraUsers = async () => {
    try {
      showLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Attendee/GetEncoraUsersByUserType?UserType=encora`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getPassCode()}`,
          },
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        // Sort the users by name (firstName + lastName) alphabetically
        const sortedEncoraUsers = data.sort((a, b) => {
          const nameA = (a.name)
          const nameB = (b.name)
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
        const updatedEncoraUsers = sortedEncoraUsers.map(user => ({
          ...user,
          isSelected: testSelectedCoordinator.some(coordinator => coordinator.userId === user.userId)
        }));
        setEncoraUsers(updatedEncoraUsers);
        //showLoading(false);
      } else {
        showLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCoordinatorsByEventId(eventId);
    setcommitteEmail("cab@encora.com");
  }, [eventId]);

  const handleContactChange = async (id, field, value) => {
    const updatedCoordinators = coordinators.map((coordinator) => {
      return coordinator.userId === id
        ? { ...coordinator, [field]: value }
        : coordinator;
    });
    await setCoordinators(updatedCoordinators);
  };

  const [deleteCoordinator, setDeleteCoordinator] = useState(null);
  const handleDelete = (id) => {
    setCoordinators(
      coordinators.filter((coordinator) => coordinator.userId !== id)
    );
    setEncoraUsers(
      encoraUsers.map((user) => {
        if (user.userId === id) {
          user.isSelected = false;
        }
        return { ...user };
      })
    );
  };

  const handleOpenDeleteModal = async (_coordinator) => { 
    const cD = {
      cid: _coordinator.coordinatorId || null, 
      uid: _coordinator.userId || null,
      name: _coordinator.firstName+' '+_coordinator.lastName
    }
    setShowDeleteModal(true); 
    setDeleteCoordinator(cD); 
  };
  const handleCloseDeleteModal = () => {setShowDeleteModal(false); setDeleteCoordinator(null); }

  const handleConfirmDelete = async () => {
    try {
          if(deleteCoordinator === null) { setShowDeleteModal(false); return };
          showLoading(true);
          if(!deleteCoordinator.cid){
            handleDelete(deleteCoordinator.uid);
            toast.success('Coordinator Removed.');
          }else{
            const response = await fetch(`${process.env.REACT_APP_API_URL}/EventCoordinator/deleteEventCoordinator?CoordinatorId=${deleteCoordinator.cid}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${getPassCode()}`,
                    'Accept': "*/*",
                    'Content-Type': 'application/json'
                }
            });

            if(checkApiError(response.status)){ navigate("/login"); return; }

            if (response.status === 200) {
                handleDelete(deleteCoordinator.uid);
                toast.success('Coordinator Removed.');
            }else{
              toast.error('Error while removing coordinator');
            }
          }
      } catch (error) {
        toast.error('Error while removing coordinator');
      } finally {
          setDeleteCoordinator(null);
          setShowDeleteModal(false);
          showLoading(false);
      }
  };

  const selectContactInfo = (id) => {
    setEncoraUsers(
      encoraUsers.filter((item) => {
        if (item.userId === id) {
          item.isSelected = true;
        }
        return { ...item };
      })
    );
    getUsersById(id);
  };

  useImperativeHandle(ref, () => ({
    validateContactInfo: () => {
      return validateInput();
    },
    getContacts: () => {
      return { committeEmail, coordinators, isEventCoordinatorSelected };
    },
  }));

  const validateInput = () => {
    setCoordinators(
      coordinators.map((item) => {
        /* if (!item.contactNumber) {
          item.contactNumberError = "Please Enter Contact Number";
        } else {
          item.contactNumberError = "";
        } */
       item.contactNumber = item.contactNumber || "";
       return { ...item };
      })
    );

    setIsEventCoordinatorSelected(coordinators.length === 0);
  };

  const getUsersById = async (userId) => {
    try {
      showLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Attendee/GetUsersById?userIds=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${getPassCode()}`, // Assuming you need to pass the token
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setCoordinators([...coordinators, ...data]);
      } else {
        console.error("Error, Getting Contact Info Users:", response.status);
      }
    } catch (error) {
      console.error("Error, Getting Contact Info Users:", error);
    } finally {
      showLoading(false);
    }
  };

  return (
    <>
      <div className="contactinfo-container">
        <p className="fw-500 mb-3 color-gray s-h">Add Contact Info</p>

        {/* Organizing Committee Email */}
        <div className="col-12 col-md-4 mb-3">
          <label className="form-label">Organizing Committee Email:</label>
          <input
            type="email"
            className="form-control"
            value={committeEmail}
            readOnly
            disabled
          />
        </div>

        <div className="select-coordinator card border mb-4">
          <div className="card-body p-0 p-md-3">
            <label className="form-label">Select Event Coordinator:</label>

            <div className="col-12 col-md-4 mb-3 d-flex ">
              <div className="custom-dropdown w-100">
                <Dropdown style={{ minWidth: "125px" }}>
                  <Dropdown.Toggle variant="outline-secondary w-100 text-start">
                    Select Coordinator
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {encoraUsers &&
                      encoraUsers.length > 0 &&
                      encoraUsers.map((option) => (
                        <Form.Check
                          key={option.name}
                          type="checkbox"
                          label={option.name}
                          checked={option.isSelected}
                          onChange={() => selectContactInfo(option.userId)}
                          className="ms-3"
                          disabled={option.isSelected}
                        />
                      ))}
                  </Dropdown.Menu>
                </Dropdown>

                {isEventCoordinatorSelected && (
                  <div className="container">
                    <div className="text-danger small mt-1">
                      Please Select Event Coordinator
                    </div>
                  </div>
                )}
              </div>
            </div>         

            {/* Coordinators List */}
            <div className="d-flex coordinators-list">
              {coordinators.map((coordinator, index) => (
                <div className="mb-3 me-md-3" key={coordinator.userId}>
                  <div className="card border shadow-none">
                    <div className="card-body p-3 p-md-3">
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="coordinator-count fs-0-9 fw-600 bg-light-sky">
                          {index + 1}
                        </div>
                        <div
                          className="me-3"
                          style={{ minWidth: "80px", minHeight: "80px" }}
                        >
                          { (coordinator.profilePhotoPath === "" || coordinator.profilePhotoPath === null) ? (
                            <img
                              src='/no-img.png'
                              alt=""
                              className="rounded-circle"
                              width="80"
                              height="80"
                            />
                          ): (
                            <img
                              src={process.env.REACT_APP_API_URL+'/'+coordinator.profilePhotoPath}
                              alt={coordinator.firstName + " " + coordinator.lastName}
                              className="rounded-circle"
                              width="80"
                              height="80"
                            />
                          )}                          
                        </div>
                        <div className="flex-grow-1 d-flex justify-content-start align-items-start align-items-sm-center flex-column flex-sm-row">
                          <div className="me-4 mb-2 mb-md-0">
                            <p className="mb-1 fw-500">
                              {coordinator.firstName + " " + coordinator.lastName}
                            </p>
                            <p className="m-0 fs-0-9 mw-120-desktop">{coordinator.designation}</p>
                          </div>
                          <div className="">
                            <p className="mb-2 text-break">
                              <a
                                href={`mailto:${coordinator.emailId}`}
                                className="color-purple"
                              >
                                {" "}
                                {coordinator.emailId}{" "}
                              </a>
                            </p>
                            <p className="m-0 text-break">
                              <a
                                href={coordinator.linkedInProfileURL}
                                className={`text-decoration-none ${coordinator.linkedInProfileURL.indexOf("https")=== -1 ? 'hide' : ''}`}
                                target="_blank"
                              >
                                <span className="icon-linkedin me-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    fill="currentColor"
                                    className="bi bi-linkedin"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
                                  </svg>
                                </span>
                                <span className="linkedin-link color-purple hide">
                                  {coordinator.linkedInProfileURL}
                                </span>{" "}
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="input-group mt-3">
                          <span
                            className="input-group-text bg-light-sky"
                            id="basic-addon1"
                          >
                            <span className="text-danger"></span> Contact Number:
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Contact Number"
                            value={coordinator.contactNumber}
                            onChange={(e) =>
                              handleContactChange(
                                coordinator.userId,
                                "contactNumber",
                                e.target.value
                              )
                            }
                            onKeyDown={(e) => {
                              if (
                                [
                                  "Backspace",
                                  "Delete",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Tab",
                                ].includes(e.key)
                              ) {
                                return;
                              }

                              if (!/^[0-9+]$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            maxLength="20"
                          />

                          <div className="container">
                            {coordinator.contactNumberError && (
                              <div className="text-danger small mt-1">
                                {coordinator.contactNumberError}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm icon-trash light-gray"
                        onClick={() => handleOpenDeleteModal(coordinator)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-trash"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
          <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              Do you want to remove the coordinator <span className="fw-bold">{deleteCoordinator?.name}</span> from this event?
          </Modal.Body>
          <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseDeleteModal}>
                  Cancel
              </Button>
              <Button variant="danger" onClick={handleConfirmDelete}>
                  Delete
              </Button>
          </Modal.Footer>
      </Modal>
    </>
  );
});

export default ContactInfo;
